const React = require('react');

const Content = require('../common/Content.jsx');
const Token = require('../utility/Token.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region DATE

function _Date(props) { return <Content.LabelValue {...props} formatValue={false} value={props.content} /> }
const Date = Content.withLabelTokenParsing(_Date, (props, keyword) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.Date:
            replaceString = data.Date;
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const TokensDate = () => [{ display: 'Date', token: Token.Date }];
const TypeConfigDate = {
    panel: {
        block: Content.TypeConfig.labelValue.panelV2.block,
        description: Content.TypeConfig.labelValue.panelV2.description,
        label: (display) => Content.TypeConfig.labelValue.panelV2.label(Utilities.wrapTextForEditor({ text: display || 'Date:'})),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: () => Content.TypeConfig.labelValue.panelV2.value(Utilities.wrapTextForEditor({ text: `{${Token.Date}}`, token: Token.Date }))
    }
};

// #endregion DATE

// #region NOTES

function _Notes(props) {
    const data = props.data || {};
    const hasValue = !Utilities.isNullOrWhitespace(data.Notes);
    if (!props.builder) {
        if (!hasValue) {
            return null;
        }
        const config = props.config || {};
        if (!props.forceVisibility && !Utilities.Config.getVisibility(config, 'Notes')) {
            return null;
        }
    }
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={!hasValue} value={props.content} />;
}
const Notes = Content.withLabelTokenParsing(_Notes, (props, keyword) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.Notes:
            if (!Utilities.isNullOrWhitespace(data.Notes)) {
                replaceString = Token.cleanTokenValueForReplacement(data.Notes);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const TokensNotes = () => [{ display: 'Notes', token: Token.Notes }];
const TypeConfigNotes = {
    panel: {
        block: Content.TypeConfig.labelValue.panelV2.block,
        description: Content.TypeConfig.labelValue.panelV2.description,
        label: (display) => Content.TypeConfig.labelValue.panelV2.label(Utilities.wrapTextForEditor({ text: display || 'Notes:'})),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: () => Content.TypeConfig.labelValue.panelV2.value(Utilities.wrapTextForEditor({ text: `{${Token.Notes}}`, token: Token.Notes })),
        visibility: (display) => {
            return {
                options: [
                    {
                        configurableDuringExport: () => true,
                        display: display || 'Notes',
                        name: 'Notes',
                        type: 'checkbox',
                        value: true,
                        visible: () => false
                    }
                ]
            };
        }
    }
};

// #endregion NOTES

// #region STAFF

function _Staff(props) {
    const data = props.data || {};
    const hasValue = !Utilities.isNullOrWhitespace(data.StaffName);
    if (!props.builder) {
        if (!hasValue) {
            return null;
        }
        const config = props.config || {};
        if (!props.forceVisibility && !Utilities.Config.getVisibility(config, 'Staff')) {
            return null;
        }
    }
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={!hasValue} value={props.content} />;
}
const Staff = Content.withLabelTokenParsing(_Staff, (props, keyword) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.StaffName:
            if (!Utilities.isNullOrWhitespace(data.StaffName)) {
                replaceString = data.StaffName;
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const TokensStaff = () => [{ display: 'Staff Name', token: Token.StaffName }];
const TypeConfigStaff = {
    panel: {
        block: Content.TypeConfig.labelValue.panelV2.block,
        description: Content.TypeConfig.labelValue.panelV2.description,
        label: (display) => Content.TypeConfig.labelValue.panelV2.label(Utilities.wrapTextForEditor({ text: display || 'Staff:'})),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: () => Content.TypeConfig.labelValue.panelV2.value(Utilities.wrapTextForEditor({ text: `{${Token.StaffName}}`, token: Token.StaffName })),
        visibility: () => {
            return {
                options: [
                    {
                        configurableDuringExport: () => true,
                        display: 'Staff',
                        name: 'Staff',
                        type: 'checkbox',
                        value: true,
                        visible: () => false
                    }
                ]
            };
        }
    }
};

// #endregion STAFF

module.exports = {
    Date: {
        Component: Date,
        Tokens: TokensDate,
        TypeConfig: TypeConfigDate
    },
    Notes: {
        Component: Notes,
        Tokens: TokensNotes,
        TypeConfig: TypeConfigNotes
    },
    Staff: {
        Component: Staff,
        Tokens: TokensStaff,
        TypeConfig: TypeConfigStaff
    }
};